'use client';

import { CollectionBannerElementDataType } from '@/components/sections/builder/elements/body/collection-banner/type';
import { ElementProps } from '@/components/sections/builder/types';
import { useCollectionDetail } from '@/hooks/api/storefront/collections';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import { useParams } from 'next/navigation';

export default function ElementContentCollectionBanner({ element }: ElementProps) {
  const { slug } = useParams<{ slug: string }>();

  const content = element.data as CollectionBannerElementDataType;

  const { data: data } = useCollectionDetail(slug, {
    enabled: slug !== 'all',
  });

  return (
    <>
      <section className={cn('bg_collection_banner bg-white')}>
        <div className='theme_layout_page_width mx-auto py-10 duration-100'>
          <div className='container mx-auto max-w-screen-xl px-4'>
            <div className='flex h-full flex-col items-stretch justify-between gap-16 md:flex-row'>
              {slug === 'all' ? (
                <h1 className='theme_font_heading text-4xl font-semibold'>All Product</h1>
              ) : (
                <>
                  <div className='flex w-full flex-col space-y-3 md:w-1/2'>
                    <h1 className='theme_font_heading text-4xl'>
                      {data?.data?.collection_name || 'Title Fallback'}
                    </h1>
                    {content.isShowDescription && (
                      <div
                        className='relative'
                        dangerouslySetInnerHTML={{
                          __html: data?.data?.description || '<p>Description Fallback</p>',
                        }}
                      />
                    )}
                  </div>
                  {content.isShowImage && data?.data?.img_url && (
                    <div className='flex w-full items-stretch md:w-1/2'>
                      <div className='relative h-full min-h-[200px] w-full'>
                        <Image
                          src={data?.data?.img_url as string}
                          alt='collection banner'
                          fill
                          objectFit='cover'
                          className='rounded-2xl'
                        />
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </section>
      <style jsx>
        {`
          .bg_collection_banner {
            background-color: ${content.colorScheme?.background || 'white'};
            color: ${content.colorScheme?.text || '#52535B'};
          }
        `}
      </style>
    </>
  );
}
